import { useState } from "react"
import { useMutation, useQueryClient } from "@tanstack/react-query"
// api
import { updateUserData, UpdateUserDataRequest, UpdateUserDataResponse, USER_KEYS } from "api"
// context
import useAuthenticationContext from "context/Authentication/useAuthenticationContext"

export const useOnboarding = (onSuccessfulSubmit?: () => void) => {
  const queryClient = useQueryClient()
  const [error, setError] = useState()
  const { user } = useAuthenticationContext()

  const {
    mutate: _updateUserData,
    isLoading,
    isError,
  } = useMutation<UpdateUserDataResponse, unknown, UpdateUserDataRequest>({
    mutationFn: updateUserData,
    onSuccess: () => {
      queryClient.invalidateQueries([USER_KEYS.STRAPI_USER])

      onSuccessfulSubmit && onSuccessfulSubmit()
    },
    onError: (err: any) => {
      setError(err?.response?.data?.error?.message)
    },
  })

  return { updateUserData: _updateUserData, isLoading, isError, error, user }
}
